module.exports = __webpack_public_path__ + "img/icon-gift-bonus-gray.0b1ceb70.svg";